import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M24 0v24H0V0h24Zm-1 1H1v22h22V1Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  "fill-rule": "evenodd",
  d: "M11.5 3.014v1.001a7.953 7.953 0 0 0-3.06.819l-.501-.868a8.99 8.99 0 0 0-.866.5l.501.869a8.044 8.044 0 0 0-2.24 2.24l-.867-.502a8.99 8.99 0 0 0-.5.866l.867.5a7.953 7.953 0 0 0-.819 3.061H3.014a9.146 9.146 0 0 0 0 1h1.001a7.954 7.954 0 0 0 .819 3.06l-.868.501c.151.299.319.587.5.866l.869-.501a8.044 8.044 0 0 0 2.24 2.24l-.502.867c.279.182.568.35.866.5l.5-.867a7.952 7.952 0 0 0 3.061.819v1.001a9.106 9.106 0 0 0 1 0v-1.001a7.953 7.953 0 0 0 3.06-.819l.501.868c.299-.151.587-.319.866-.5l-.501-.869a8.044 8.044 0 0 0 2.24-2.24l.867.502c.182-.279.35-.567.5-.866l-.867-.5a7.953 7.953 0 0 0 .819-3.061h1.001a9.106 9.106 0 0 0 0-1h-1.001a7.952 7.952 0 0 0-.819-3.06l.868-.501a8.999 8.999 0 0 0-.5-.866l-.869.501a8.044 8.044 0 0 0-2.24-2.24l.502-.867a8.987 8.987 0 0 0-.866-.5l-.5.867a7.954 7.954 0 0 0-3.061-.819V3.014a9.146 9.146 0 0 0-1 0ZM12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  "fill-rule": "evenodd",
  d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }